import authOverrides from 'aws-auth-overrides';
import { Amplify, Auth, Hub } from 'aws-amplify';
import awsExports from 'aws-exports';
import amplifyAuthHandler from 'amplify/handlers';

const initializer = (setAuthorizedUserContext) => {
  const auth = authOverrides();
  const awsConfig = awsExports();

  Amplify.configure(awsConfig);
  Auth.configure(auth);
  Hub.listen('auth', (data) => amplifyAuthHandler(data, setAuthorizedUserContext));
};

export default initializer;
